import { t } from '../hooks/translations'
import css from '../style.module.scss'

type ErrorScreenProps = {
  error: any
}

export const ErrorScreen = function ErrorScreen({ error }: ErrorScreenProps) {
  return (
    <div className={css['container-aligned']}>
      <p className={css.paragraph}>
        {t('failed_to_load_component')}{' '}
        <a href="mailto:help@snow-forecast.com">help@snow-forecast.com</a>
      </p>
      <p className={css['submit-error']}>{String(error)}</p>
    </div>
  )
}
